module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_save-e0d2f06538fb3356822424a5636d6353.svg";